import React from "react";

import { Button } from "./button";
import { OvertimeStatus } from "./OvertimeStatus";

export function OvertimeStatusButton(props: { overtime: Overtime; onClick: () => void }) {
  const { overtime, onClick } = props;
  return (
    <>
      {overtime.status === "pending" && (
        <Button colour="primary" size="sm" title="Your overtime request is pending approval" onClick={onClick}>
          Overtime <OvertimeStatus overtimeStatus={overtime.status} />
        </Button>
      )}
      {overtime.status === "declined" && (
        <Button colour="danger" size="sm" title="Overtime request has been declined" onClick={onClick}>
          Overtime <OvertimeStatus overtimeStatus={overtime.status} />
        </Button>
      )}
      {overtime.status === "approved" && (
        <Button colour="success" size="sm" title="Overtime request has been approved" onClick={onClick}>
          Overtime <OvertimeStatus overtimeStatus={overtime.status} />
        </Button>
      )}
    </>
  );
}
